import * as React from "react";
import { LocalizedComponentProps } from "bernie-l10n";
import { ExtendedContextStore } from "typings/flexFramework/FlexDefinitions";
import { Logger } from "bernie-logger";
import { BlossomComponent } from "components/flexFramework/domain/BlossomComponent";
import { UitkHeading, UitkHeadingProps } from "uitk-react-text";
import { UitkSpacing } from "uitk-react-spacing";
import { NativeAd } from "components/utility/Ads/NativeAd";
import { FlexComponent, FlexComponentProps, ModuleDefinition } from "typings/flexFramework/FlexComponent";

export interface BlossomComponentsProps extends LocalizedComponentProps {
  context: ExtendedContextStore;
  logger?: Logger;
  blossomComponent?: BlossomComponent;
  flexComponents?: FlexComponent[];
  moduleDefinitions?: ModuleDefinition[];
}

interface GridViewProps extends FlexComponentProps {
  moduleDefinition?: ModuleDefinition;
  title: string;
  innerTitle: string;
  uci: string;
}

interface TitleProps {
  title: string;
}

const headingConfig: UitkHeadingProps = { tag: "h2", size: 3 };
const Title: React.FC<TitleProps> = ({ title }) => (
  <UitkSpacing padding={{ blockend: "three" }}>
    <UitkHeading {...headingConfig}>{title}</UitkHeading>
  </UitkSpacing>
);

export const MarqueeSingleCardView: React.FC<GridViewProps> = ({ context, title, innerTitle, uci }) => {
  return (
    <>
      {title && <Title title={title} />}
      {innerTitle && <Title title={innerTitle} />}
      <div className="meso-native-card-full-bleed">
        <NativeAd uci={uci} type="marquee" />
      </div>
    </>
  );
};
